import { JSBridgeApp } from './app'
import { JSBridgeBrowser } from './browser'
import { JSBridgeCore } from './core/JSBridgeCore'
import { JSBridgeMiniprogram } from './miniprogram'
import { isAndroid, isIOS, isRealseeVRWebview, isWxMiniProgram } from './utils/clientDetector'
import { JSBridgeOptions } from './typings/JSBridgeOptions'
export type { JSBridgeProtocol } from './typings/JSBridgeProtocol'
export type { StaticData } from './typings/StaticData'

/**
 * 平台相关的jsBridge类，根据平台自动加载不同的jsBridge实例
 */
// @ts-ignore
export default class JSBridge extends JSBridgeCore {
  constructor(options: Partial<JSBridgeOptions> = {}) {
    super()
    if (isRealseeVRWebview() && (isAndroid() || isIOS())) return new JSBridgeApp(options)
    if (isWxMiniProgram()) return new JSBridgeMiniprogram(options)
    return new JSBridgeBrowser()
  }
}

export { JSBridgeApp, JSBridgeBrowser, JSBridgeMiniprogram, JSBridgeCore }
